<div>
  <form [formGroup]="timeForm">
    <label [for]="button?.button_id">{{ button?.button_headline }}</label>
    <p *ngIf="button?.button_subhead" class="text-muted">
      {{ button?.button_subhead }}
    </p>
    <md-slider
      class="w-100"
      labeled
      [ticks]="showTicks"
      [step]="step"
      [min]="min"
      [max]="max"
      [value]="timeForm?.get('value')?.value"
      (change)="valueChange($event)"
      [disabled]="button?.button_disable"
    ></md-slider>

    <div *ngIf="f.value.errors" class="invalid-feedback">
      <div *ngIf="f.value.errors.required">
        {{ errorMsgList["required"] }}
      </div>
      <div *ngIf="f.value.errors.minlength">
        {{ errorMsgList["minlength"] }}
      </div>
      <div *ngIf="f.value.errors.maxlength">
        {{ errorMsgList["maxlength"] }}
      </div>
      <div *ngIf="f.value.errors.pattern">
        {{ errorMsgList["pattern"] }}
      </div>
    </div>
  </form>
</div>
